import { IOrderClause } from '@tableau/catalog-ui-temp';
import React from 'react';

import { IAuthenticationProvider, ISiteAuthenticationSettings, SiteAuthenticationSettingsService } from '../../services/SiteAuthenticationSettingsService';
import { AuthenticationColumnKeys, AuthenticationTypesGrid } from './AuthenticationTypesGrid';

export type AuthenticationTypesDialogProps = {
    enabledSAMLConfigForSCIM: string;
    refreshAuthentication: () => void;
    refreshEmbeddedProviders: () => void;
    scimIdpConfigurationIds: string[];
    embeddedProviderIdpConfigurationId?: string;
};

export type AuthenticationTypesDialogState = {
    currentColumnSortOrder: IOrderClause;
    allProviders: IAuthenticationProvider[];
};

export class AuthenticationTypesDialog extends React.Component<AuthenticationTypesDialogProps, AuthenticationTypesDialogState> {

    constructor(props: AuthenticationTypesDialogProps) {
        super(props);
        this.state = {
            currentColumnSortOrder: {
                field: '',
                ascending: false
            },
            allProviders: []
        };
    }

    componentDidMount(): void {
        this.setUpInitialState();
    }

    private setUpInitialState(refresh: boolean = false) {
        SiteAuthenticationSettingsService.getSiteAuthenticationSettings(refresh).then((siteAuthSettings: ISiteAuthenticationSettings) => {
            this.setState({ allProviders: siteAuthSettings.allProviders });
        });
    }

    // Callback Method provided for sortable method
    private changeColumnSort = (field: string) => {
        const currentColumnSortOrder = this.state.currentColumnSortOrder;
        const ascending = field === currentColumnSortOrder.field ? !currentColumnSortOrder.ascending : true;
        this.setState({currentColumnSortOrder: { field, ascending }}, () => { this.sortDisplayData(field, ascending); });
    };

    // Method that is called when a user clicks on a sortable column
    private sortDisplayData = (field: string, ascending: boolean) => {
        let unsortedProviders = this.state.allProviders;
        if (field === AuthenticationColumnKeys.AuthenticationName) {
            unsortedProviders.sort((provider1 , provider2) => {
                return ascending ? provider1.idpConfigurationName.localeCompare(provider2.idpConfigurationName)
                    : provider2.idpConfigurationName.localeCompare(provider1.idpConfigurationName);
            });
        } else if (field === AuthenticationColumnKeys.Status) {
            unsortedProviders.sort((provider1 , provider2) => {
                if (ascending) {
                    return (provider1.isEnabled === provider2.isEnabled) ? 0 : provider1.isEnabled ? -1 : 1;
                } else {
                    return (provider1.isEnabled === provider2.isEnabled) ? 0 : provider2.isEnabled ? -1 : 1;
                }
            });
        } else if (field === AuthenticationColumnKeys.AuthenticationType) {
            unsortedProviders.sort((provider1 , provider2) => {
                const provider1Type = provider1.alias ? provider1.alias : provider1.type;
                const provider2Type = provider2.alias ? provider2.alias : provider2.type;
                return ascending ? provider1Type.localeCompare(provider2Type) : provider2Type.localeCompare(provider1Type);
            });
        }
        this.setState({ allProviders: unsortedProviders });
    };

    public render(): JSX.Element {

        return (
            <div>
                <AuthenticationTypesGrid
                    currentColumnSortOrder={this.state.currentColumnSortOrder}
                    handleColumnSortOrderChange={this.changeColumnSort}
                    displayData={this.state.allProviders}
                    refreshGrid={() => { this.setUpInitialState(); } }
                    enabledSAMLConfigForSCIM={this.props.enabledSAMLConfigForSCIM}
                    scimIdpConfigurationIds={this.props.scimIdpConfigurationIds}
                    refreshAuthentication={this.props.refreshAuthentication}
                    refreshEmbeddedProviders={this.props.refreshEmbeddedProviders}
                    embeddedProviderIdpConfigurationId={this.props.embeddedProviderIdpConfigurationId}
                />
            </div>
        );
    }
}